import { Component, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { OffersService } from '../../services/offers.service'
import { OrganizationsService } from 'src/app/modules/organization/services/organizations.service'
import { environment } from 'src/environments/environment'
import { TranslateService } from '@ngx-translate/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import { offerFilter, offerList } from 'src/app/modules/offers/models/offer.model'
import { offersStatus } from 'src/app/modules/offers/models/offers.enum'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
	selector: 'app-offers-list',
	templateUrl: './offers-list.component.html',
	styleUrls: ['./offers-list.component.scss'],
})
export class OffersListComponent implements OnInit {
	subscription = new Subscription()
	activeCountries!: any
	attachementUrl = environment.attachmentPath
	offers!: offerList[]
	offersStatus = offersStatus
	totalCount!: number
	offerFilter: offerFilter = {
		SearchText: '',
		paging: { pageNumber: 1, pageSize: 10 },
		offerActiveTab: 0,
		countryId: 224,
	}
	constructor(
		private OffersService: OffersService,
		private SharedService: SharedService,
		private organizationServ: OrganizationsService,
		public translate: TranslateService,
		private router: Router,
		public ActivatedRoute: ActivatedRoute
	) {
		this.SharedService.headerTitle.next(`OFFERS.OFFERS_LIST.PAGE_TITLE`)
	}

	ngOnInit(): void {
		this.getActiveCountries()

		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.offerFilter.countryId = res['country'] || 224
				this.offerFilter.offerActiveTab = res['ActiveTab'] || 0
				this.offerFilter.paging.pageNumber = res['page'] || 1
				this.offerFilter.paging.pageSize = res['count'] || 10
				this.getOfferList()
				this.SharedService.handleBreadCrumb('offer', true, {
					name: '',
					id: null,
					url: '/layout/offer',
					queryParams: { ...res },
				})
			})
		)
	}

	getActiveCountries() {
		this.subscription.add(
			this.organizationServ.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}

	getOfferList() {
		this.subscription.add(
			this.OffersService.getOffersList(this.offerFilter).subscribe((res) => {
				this.offers = res.items
				this.totalCount = res.totalCount
			})
		)
	}

	FabNavigation() {
		this.router.navigate(['/layout/offer/add-promo-code'])
	}

	deleteOffer(id: any) {
		this.subscription.add(
			this.OffersService.deleteOffer(id).subscribe((res) => {
				this.getOfferList()
			})
		)
	}

	updateOfferStatus(offer: any) {
		let requestBody = {
			id: offer.id,
			isActive: !offer.isActive,
		}
		this.subscription.add(
			this.OffersService.updateOfferStatus(requestBody).subscribe((res) => {
				this.getOfferList()
			})
		)
	}

	tapChanged(event: any) {
		this.router.navigate(['/layout/offer'], {
			queryParams: {
				country: this.offerFilter.countryId,
				ActiveTab: event,
			},
		})
	}

	pageChanged(pageNumber: number, pageCount: number) {
		this.router.navigate(['/layout/offer'], {
			queryParams: {
				country: this.offerFilter.countryId,
				ActiveTab: this.offerFilter.offerActiveTab,
				page: pageNumber,
				count: pageCount,
			},
		})
	}
	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
